export default __webpack_public_path__ + "images/1e7b6ceeeb69d50bc2bae0b6f37bac36.svg";